"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transformWeekDaysArrayToObject = function (data) {
    var obj = {
        monday: data.includes('monday'),
        tuesday: data.includes('tuesday'),
        wednesday: data.includes('wednesday'),
        thursday: data.includes('thursday'),
        friday: data.includes('friday'),
    };
    return obj;
};
exports.default = transformWeekDaysArrayToObject;
